// extracted by mini-css-extract-plugin
module.exports = {"error":"error--ed8f97"};